module.exports = __webpack_public_path__ + "img/LocalHospitalOutlined.260bd5ec.svg";